export default {
  SET_IS_SIC: "casino/SET_IS_SIC",
  SET_GAMBLING_SESSION: "casino/SET_GAMBLING_SESSION"
};
